import { required, email, regex } from 'vee-validate/dist/rules'
import { extend, ValidationProvider, ValidationObserver, setInteractionMode } from "vee-validate"
import ModalCreate from '@/views/clients/componentes/ModalCreate.vue';

setInteractionMode("eager")
extend("required", {
    ...required,
    message: "{_field_} no puede estar vacio",
});
extend('email', {
    ...email,
    message: 'El {_field_} no es una dirección válida'
});
extend('numeric', {
    ...regex,
    message: 'El {_field_} solo puede contener números',
    validate: value => /^[0-9]+$/.test(value),
});
import { mapGetters } from 'vuex';
import colors from 'vuetify/lib/util/colors';
const clients = {
    components: { ValidationObserver, ValidationProvider, ModalCreate },
    data: () => ({
        loadingTbl: false,
        loadingDel: {},
        loading: false,
        headers: [
            { text: "DNI", value: "in_NumDocumentoIdentidad", align: 'start', sortable: false, class: 'text_white' },
            { text: "Nombres", value: "vc_Nombres", align: 'start', sortable: false },
            { text: "Apellido Paterno", value: "vc_ApePaterno", align: 'start', sortable: false },
            { text: "Apellido Materno", value: "vc_ApeMaterno", align: 'start', sortable: false },
            // { text: "Correo Personal", value: "vc_Correo", align: 'start', sortable: false },
            { text: "Correo Corporativo", value: "vc_correo_corporativo", align: 'start', sortable: false },
            { text: "País", value: "in_PaisId", align: 'start', sortable: false },
            { text: "Centros asignados", value: "centros", align: 'start', sortable: false },
            // { text: "Segmento ID", value: "in_SegmentoId", align: 'start', sortable: false },
            { text: "Acciones", value: "action", align: 'start', sortable: false },
        ],
        clients: [],
        dialog: false,
        valid: false,
        menuNacimiento: false,
        menuIngreso: false,
        form: {
            id: null,
            tipoDocumento: null,
            campana: null,
            centro: null,
            segmento: null,
            numDocumento: '',
            nombres: '',
            apellidoPaterno: '',
            apellidoMaterno: '',
            sexo: null,
            fechaNacimiento: null,
            correoPersonal: '',
            correoCorporativo: '',
            telefono: '',
            pais: null,
            perfil: 39,
            modalidad: 3,
            in_flat: 0
        },
        tipoDocumentos: [],
        sexos: [
            { text: 'Masculino', value: 0 },
            { text: 'Femenino', value: 1 }
        ],
        paises: [],
        perfil: '39',
        modalidad: '3',
        centros: [],
        campanas: [],
        segmentos: [],
        watchEnabled: true, // Bandera para controlar los watchers
        showCampanasDialog: false,
        currentCampanas: [],
    }),
    mounted() {
        this.fetchClients();
        /*this.fetchDocId();
        this.fetchCountry();
        this.fetchCenter();
        this.fetchCampaign();
        this.fetchSegment();*/
    },
    watch: {
      
    },
    computed: {
        ...mapGetters(['getPaises', 'getCentros', 'getSegmentos', 'getCampanas']),
        filteredCentros() {
            return this.getCentros.filter(centro => centro.inPaisId === this.form.pais).sort((a, b) => a.vc_Descripcion.localeCompare(b.vc_Descripcion));
        },
        filteredSegmentos() {
            let segmentos = []
            let uniqueSegmento = []
            console.log(this.form.segmento, this.form.centro);
            

            if(this.form.centro != null && this.form.centro != undefined){

                segmentos = this.getCampanas.filter(item => this.form.centro.includes(item.in_CentroId)).map(item => item.in_SegmentoId);
    
                uniqueSegmento = [...new Set(segmentos)];
    
                return this.getSegmentos.filter(item => uniqueSegmento.includes(item.Id)).sort((a, b) => a.vc_Descripcion.localeCompare(b.vc_Descripcion));
            }
        },
        filteredCampanas() {
            let campanas = [];
            console.log(this.form.segmento, this.form.centro);
            
            if(this.form.segmento != null && this.form.segmento != undefined && this.form.centro != null && this.form.centro != undefined){
                campanas = this.getCampanas.
                    filter(item => this.form.centro.includes(item.in_CentroId)).
                    filter(item => this.form.segmento.includes(item.in_SegmentoId));
    
                return campanas.sort((a, b) => a.vc_Descripcion.localeCompare(b.vc_Descripcion));
            }
        }
    },
    methods: {
        getCountryName(paisId) {
            const country = this.getPaises.find(pais => pais.Id === paisId);
            return country ? country.vc_Descripcion : '';
        },
        openCampanasDialog(campanas) {
            this.currentCampanas = campanas;
            this.showCampanasDialog = true;
        },
        limpiar() {
            this.form = {
                id: null,
                tipoDocumento: null,
                campana: null,
                centro: null,
                segmento: null,
                numDocumento: '',
                nombres: '',
                apellidoPaterno: '',
                apellidoMaterno: '',
                sexo: null,
                fechaNacimiento: null,
                correoPersonal: '',
                correoCorporativo: '',
                telefono: '',
                pais: null,
                perfil: 39,
                modalidad: 3,
                in_flat: 0,
                usuario_id: 0
            }
        },
        cancel() {
            // this.$refs.datos.reset();
            this.watchEnabled = false;
            this.limpiar();
            this.dialog = false;
        },
        async fetchClients() {
            this.loadingTbl = true;
            try {
                const response = await this.$axios.get('getClients');
                this.clients = response.data.all;
            } catch (error) {
                console.error('Error al obtener los empleados:', error);
            } finally {
                this.loadingTbl = false;
            }
        },
        async fetchDocId() {
            try {
                const response = await this.$axios.get('getDocId');
                this.tipoDocumentos = response.data;
            } catch (error) {
                console.error('Error al obtener los empleados:', error);
            }
        },
        async fetchCountry() {
            try {
                const response = await this.$axios.get('getCountry');
                this.paises = response.data;
            } catch (error) {
                console.error('Error al obtener los empleados:', error);
            }
        },
        async fetchCenter() {
            try {
                const response = await this.$axios.get('getCenter');
                this.centros = response.data;
            } catch (error) {
                console.error('Error al obtener los empleados:', error);
            }
        },
        async fetchCampaign() {
            try {
                const response = await this.$axios.get('getCampaign');
                this.campanas = response.data;
            } catch (error) {
                console.error('Error al obtener los empleados:', error);
            }
        },
        async fetchSegment() {
            try {
                const response = await this.$axios.get('getSegment');
                this.segmentos = response.data;
            } catch (error) {
                console.error('Error al obtener los empleados:', error);
            }
        },
        async openForm() {
            this.dialog = true;
            this.watchEnabled = false;
            try {
                await Promise.all([
                    this.fetchDocId(),
                    /*this.fetchCountry(),
                    this.fetchCenter(),
                    this.fetchCampaign(),
                    //this.fetchSegment()*/
                ]);
            } catch (error) {
                console.error('Error al cargar los datos del formulario:', error);
            }
        },
        async submitForm(reset) {
            this.loading = true;
            this.form.usuario_id = this.$store.state.id;
            try {
                let response;
                if (this.form.id) {
                    response = await this.$axios.post('updateClient', this.form);
                    this.$toast.success('Datos del cliente actualizados con exito');
                } else {
                    response = await this.$axios.post('addClient', this.form);
                    this.$toast.success('Cliente agregado con exito');
                }
                this.$refs.datos.reset();
                reset();
                this.cancel();
                this.dialog = false;
                this.fetchClients();
            } catch (error) {
                if (error.response && error.response.status === 409) {
                    //alert('Usuario existente');
                    this.$toast.error('El cliente ya esta dado de alta, verifique los datos');
                } else {
                    //console.error(error);
                    this.$toast.error('Hubo un error al agregar al cliente');
                    //alert('Ocurrió un error al procesar la solicitud');
                }
            } finally {
                this.loading = false;
            }
            // Lógica para enviar el formulario
            //this.dialog = false;
        },
        async deleteClient(idclient) {
            this.$set(this.loadingDel, idclient, true);
            try {
                const response = await this.$axios.delete('deleteClient', { data: { client: idclient } });
                this.clients = this.clients.filter(f => f.id !== idclient);
                this.$toast.success('Cliente eliminado con exito');
            } catch (error) {
                this.$toast.error('Hubo un error al eliminar al cliente');
            } finally {
                this.$set(this.loadingDel, idclient, false);
            }
        },
        editClient(item) {
            this.watchEnabled = false;
            console.log('item', item);
            
            // Asigna los IDs de los centros y campañas
            const centrosIds = item.centros.map(c => c.in_CentroId);
            const campanasIds = item.campanas.map(c => c.in_CampanaId);
            const segmentosIds = [...new Set(item.campanas.map(c => c.in_SegmentoId))];

            
            this.form = {
                id: item.id,
                tipoDocumento: item.in_TipoDocumento,
                campana: campanasIds,
                centro: centrosIds,
                segmento: segmentosIds,
                numDocumento: item.in_NumDocumentoIdentidad,
                nombres: item.vc_Nombres,
                apellidoPaterno: item.vc_ApePaterno,
                apellidoMaterno: item.vc_ApeMaterno,
                sexo: item.in_Sexo,
                fechaNacimiento: item.dt_FecNacimiento,
                correoPersonal: item.vc_Correo,
                correoCorporativo: item.vc_correo_corporativo,
                telefono: item.in_telefono,
                pais: item.in_PaisId,
                perfil: 39,
                modalidad: 3,
                in_flat: item.in_flat
            },
            console.log(this.form);
            
            this.openForm(); // Abre el diálogo*/
            this.$nextTick(() => {
                this.watchEnabled = true; // Reactiva los watchers después de la carga inicial
            });
        }
    }
}
export default clients